module.exports = __webpack_public_path__ + "static/media/MainPayments.4752ac12.svg";